module.exports = __webpack_public_path__ + "static/media/bg.a9d680b8.png";